import React from 'react';
import Footer from '../../components/Layout/Footer';
import Header from '../../components/Layout/Header/Header';

export default function ReturnPolicy() {
  return (
    <div className="template-index index-demo4">
      <div className="page-wrapper">
        <div className="classic-topHeader">
          <Header />
          <div id="page-content" className="mb-0">
            <div className="container mt-5 mb-5" style={{ minHeight: '50vh' }}>
              <h1 className="text-center mb-4">RETURN POLICY</h1>
              <div className="policy-content" style={{ maxWidth: '800px', margin: '0 auto', lineHeight: '1.8' }}>
                <ul style={{ listStyleType: 'disc', paddingLeft: '20px' }}>
                  <li className="mb-3"><strong>Return Schedule:</strong> All rented camera bodies, lenses, and accessories must be returned to the Adcaster store in Kottakkal on or before the agreed time specified in the booking summary.</li>
                  <li className="mb-3"><strong>Inspection Upon Return:</strong> Every returned item undergoes a thorough physical and technical inspection by our technical team.</li>
                  <li className="mb-3"><strong>Missing Accessories:</strong> If any accompanying accessories (such as lens caps, memory cards, batteries, chargers, bags, or cables) are missing upon return, the renter must return them within 24 hours or pay the cost of replacement.</li>
                </ul>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}
